import { FAQContent, FAQContentBase } from '../types/Faq';

export const faqContentSerializer = (faqContent: FAQContentBase): FAQContent =>
  faqContent?.map((element) => ({
    ...element,
    key: element.question.replace(/[^A-Z0-9]+/gi, '-').toLowerCase(),
  }));
